import { CashierTransactionTypes } from "app/utils/const";
import React from "react";
import SimplyConnectDeposit from "../components/SimplyConnectDeposit/SimplyConnectDeposit";
import SimplyConnectWithdrawal from "../components/SimplyConnectWithdrawal/SimplyConnectWithdrawal";

type Props = {
  tab: string;
  paymentMethod?: string;
  openOrderPaymentMethod: string;
};

const NuveiFundingContent: React.FC<Props> = ({
  tab,
  paymentMethod,
  openOrderPaymentMethod,
}) => {
  const renderContent = () => {
    if (tab === CashierTransactionTypes.WITHDRAW) {
      return (
        <SimplyConnectWithdrawal
          paymentMethod={paymentMethod}
          openOrderPaymentMethod={openOrderPaymentMethod}
        />
      );
    }
    if (tab === CashierTransactionTypes.DEPOSIT) {
      return (
        <SimplyConnectDeposit
          paymentMethod={paymentMethod}
          openOrderPaymentMethod={openOrderPaymentMethod}
        />
      );
    }
    return null;
  };

  return (
    <div className="nuvei-funding__content">
      <form>{renderContent()}</form>
    </div>
  );
};

export default NuveiFundingContent;
